import { ArrowLeft } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router";

export default function BackButtonLayout({ title, right, header, className, children }: { 
    title?: string;
    right?: React.ReactNode;
    header?: React.ReactNode;
    className?: string;
    children: React.ReactNode;
 }) {

    const nav = useNavigate();

    function goBack() {
        nav(-1);
    }

    return (
        <div className="h-svh grid grid-rows-[auto_1fr]">
            <div className={className}>
                <div className="flex items-center gap-2 py-2 mx-auto max-w-screen-md">
                    <div>
                        <button onClick={goBack} className="btn btn-ghost"><ArrowLeft /></button>
                    </div>
                    <div className="flex-1">
                        <h1>{title}</h1>
                    </div>
                    {right}
                </div>
                {header}
            </div>

            <div className="overflow-auto">
                {children}
            </div>
        </div>
    );

}